<template>
    <div
        v-loading="loading"
        class="py-2">
        <div
            v-if="hasNotification"
            class="mb-4 space-y-2">
            <template
                v-for="(item, index) in notifications"
                :key="index">
                <driver-alert-item
                    :journey="journey"
                    :alert="item"
                    @skipped="alertSkipped" />
            </template>
        </div>
        <div
            v-else
            class="mb-4 space-y-2">
            Hiện tại không có thông báo nào
        </div>
    </div>
</template>
<script lang="ts" setup>
import DriverAlertItem from './driver-alert-item.vue'
const props = defineProps({
  journey: {
    type: Object,
    required: true
  }
})

const emits = defineEmits(['modify', 'skipped', 'change'])
const { journey } = toRefs(props)
const journeyId = computed(() => journey.value?.id)
const loading = ref(true)
const notifications = ref([])
const hasNotification = computed(() => notifications.value.length)

const getNotifications = () => {
  if (!journeyId.value) {
    return
  }
  notifications.value = []
  loading.value = true
  $api($urlClient.monitoring.journey.alert.get, { uriParams: { ID: journeyId.value } }).then(({ data }: any) => {
    notifications.value = ((data?.value || {}).data || []).filter((a: any) => !a.skipped)
    emits('change', notifications.value.length)
    loading.value = false
  })
}
const openModify = () => {
  emits('modify')
}
onMounted(() => {
  getNotifications()
})
const refresh = $lodash.debounce(getNotifications, 500)
const alertSkipped = (id: string) => {
  emits('skipped')
}
defineExpose({ refresh })
</script>
